__turbopack_context__.v({
  "iconWrapper": "HIPAACompliance-module__uqQtkW__iconWrapper",
  "innerContainer": "HIPAACompliance-module__uqQtkW__innerContainer",
  "section": "HIPAACompliance-module__uqQtkW__section",
  "subtitle": "HIPAACompliance-module__uqQtkW__subtitle",
  "textWrapper": "HIPAACompliance-module__uqQtkW__textWrapper",
  "title": "HIPAACompliance-module__uqQtkW__title",
  "wrapper": "HIPAACompliance-module__uqQtkW__wrapper",
});
